module.exports = __webpack_public_path__ + "img/logo-asein-light.330d4edd.png";